import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import { makeStyles } from '@material-ui/core/styles';
import MuiCheckbox from '@material-ui/core/Checkbox';
import MuiFormControlLabel from '@material-ui/core/FormControlLabel';
// Custom
import AppIcon from 'components/icons/AppIcon';
// Internal
import { getMuiColor } from './internal/Tools';

const useStyles = (customColor) => makeStyles(() => {
  let root = {};
  if (customColor) {
    root = {
      ...root,
      color: customColor,
    };
  }
  return { root };
});

const Checkbox = ({
  label, labelPlacement, checked, intermediate, primary, secondary, disabled, customColor, onChange,
}) => {
  // MUI color
  const color = getMuiColor((primary && !customColor), (secondary && !customColor));

  // Custom styles
  const classes = useStyles(customColor)();

  // Change handler
  const handleChange = onChange ? (e) => onChange(e.target.checked) : null;

  // Components props
  const formControlLabelProps = { label, labelPlacement };
  let checkboxProps = {
    checked, color, disabled, onChange: handleChange,
  };
  if (intermediate) {
    checkboxProps = {
      ...checkboxProps,
      checkedIcon: <AppIcon id="checkIntermediate" />,
    };
  }

  if (label) {
    return (
      <MuiFormControlLabel
        {...formControlLabelProps}
        control={
          <MuiCheckbox {...checkboxProps} classes={classes} />
        }
      />
    );
  }
  return (
    <MuiCheckbox {...checkboxProps} />
  );
};

Checkbox.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  labelPlacement: PropTypes.oneOf(['top', 'start', 'bottom', 'end']),
  checked: PropTypes.bool.isRequired,
  intermediate: PropTypes.bool,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  disabled: PropTypes.bool,
  customColor: PropTypes.string,
  onChange: PropTypes.func,
};

Checkbox.defaultProps = {
  label: null,
  labelPlacement: 'end',
  intermediate: false,
  primary: true,
  secondary: false,
  disabled: false,
  customColor: null,
  onChange: null,
};

export default React.memo(Checkbox);



// WEBPACK FOOTER //
// ./components/core/Checkbox.js